'use client'

;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import dynamic from 'next/dynamic'

/**
 * Lazy client boundaries for the below-fold marketing visuals. Same reasoning as
 * src/components/site/forms/lazy.tsx: `next/dynamic` only defers on the client when the boundary
 * itself is a client component — in a server component the chunk is preloaded eagerly in the
 * prerendered HTML anyway. Importing through this module keeps each visual's chunk out of the
 * [...slug] route's shared chunk set, so it is fetched only on pages that render it. The visuals
 * stay server-rendered (no `ssr: false`); only the hydration chunk is page-local.
 */
export const AiChatVisual = dynamic(() =>
  import('@/components/site/visuals/home/ai-chat-visual').then((m) => m.AiChatVisual),
)

export const BudgetVisual = dynamic(() =>
  import('@/components/site/visuals/home/budget-visual').then((m) => m.BudgetVisual),
)

export const CapacityVisual = dynamic(() =>
  import('@/components/site/visuals/home/capacity-visual').then((m) => m.CapacityVisual),
)

export const ClientDossierVisual = dynamic(() =>
  import('@/components/site/visuals/home/client-dossier-visual').then((m) => m.ClientDossierVisual),
)

export const ClientLogVisual = dynamic(() =>
  import('@/components/site/visuals/home/client-log-visual').then((m) => m.ClientLogVisual),
)

export const ClientRecordVisual = dynamic(() =>
  import('@/components/site/visuals/home/client-record-visual').then((m) => m.ClientRecordVisual),
)

export const ClientRowVisual = dynamic(() =>
  import('@/components/site/visuals/home/client-row-visual').then((m) => m.ClientRowVisual),
)

export const DashboardVisual = dynamic(() =>
  import('@/components/site/visuals/home/dashboard-visual').then((m) => m.DashboardVisual),
)

export const EmployeeHoursVisual = dynamic(() =>
  import('@/components/site/visuals/home/employee-hours-visual').then((m) => m.EmployeeHoursVisual),
)

export const ExcelGridVisual = dynamic(() =>
  import('@/components/site/visuals/home/excel-grid-visual').then((m) => m.ExcelGridVisual),
)

export const HoursAiChatVisual = dynamic(() =>
  import('@/components/site/visuals/home/hours-ai-chat-visual').then((m) => m.HoursAiChatVisual),
)

export const HoursDayVisual = dynamic(() =>
  import('@/components/site/visuals/home/hours-day-visual').then((m) => m.HoursDayVisual),
)

export const HoursVisual = dynamic(() =>
  import('@/components/site/visuals/home/hours-visual').then((m) => m.HoursVisual),
)

export const IntegrationsVisual = dynamic(() =>
  import('@/components/site/visuals/home/integrations-visual').then((m) => m.IntegrationsVisual),
)

export const LeadTimeVisual = dynamic(() =>
  import('@/components/site/visuals/home/lead-time-visual').then((m) => m.LeadTimeVisual),
)

export const MobileVisual = dynamic(() =>
  import('@/components/site/visuals/home/mobile-visual').then((m) => m.MobileVisual),
)

export const OrganogramVisual = dynamic(() =>
  import('@/components/site/visuals/home/organogram-visual').then((m) => m.OrganogramVisual),
)

export const PlanningAiChatVisual = dynamic(() =>
  import('@/components/site/visuals/home/planning-ai-chat-visual').then((m) => m.PlanningAiChatVisual),
)

export const PlanningHoursVisual = dynamic(() =>
  import('@/components/site/visuals/home/planning-hours-visual').then((m) => m.PlanningHoursVisual),
)

export const ProgressVisual = dynamic(() =>
  import('@/components/site/visuals/home/progress-visual').then((m) => m.ProgressVisual),
)

export const RecurringVisual = dynamic(() =>
  import('@/components/site/visuals/home/recurring-visual').then((m) => m.RecurringVisual),
)

export const ReportsVisual = dynamic(() =>
  import('@/components/site/visuals/home/reports-visual').then((m) => m.ReportsVisual),
)
